module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cj7UY"))).then(() => parcelRequire('d0iPb'));